
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { TreeNode, NodeType, mapProjectToTreeNode } from '@/modules/nomenclature/models/treeNode';
import * as ProjectService from '@/modules/nomenclature/services/projectService';

@Component({
  components: {}
})
export default class SubjectBudgetLinePicker extends Vue {
  private readonly INVALID_ID = 'N/A';
  @Prop({ required: false })
  protected value?: TreeNode;
  @Prop({ required: false, default: false })
  protected displayErrorMsg?: boolean;
  @Prop({ required: false, default: false })
  protected locked?: boolean;
  protected loading = false;
  protected projects: TreeNode[] = [];
  protected active: string[] = [];

  protected created(): void {
    this.loading = true;
    ProjectService.fetchAll()
      .then((response) => {
        this.projects = response.data.map((item) => {
          const projectNode = mapProjectToTreeNode(item);
          return projectNode;
        });
      })
      .finally(() => (this.loading = false));
  }

  protected async fetchProjectChildren(item: TreeNode): Promise<void> {
    return ProjectService.fetchChildren(item)
      .then((response) => {
        const children = response.data.map((item) => {
          const projectNode = mapProjectToTreeNode(item);
          return projectNode;
        });
        if (item.children) {
          item.children.push(...children);
        }
      })
      .finally(() => {
        if (item.hiddenChildren && item.children) {
          item.children.push(...item.hiddenChildren);
        }
        if (item.children && item.children.length === 0) {
          item.children.push({
            id: this.INVALID_ID,
            icon: 'mdi-alert-circle-outline',
            name: this.$i18n.t('analysis.SubjectBudgetLinePicker.noResultFound').toString(),
            nodeType: NodeType.VIRTUAL
          });
        }
      });
  }

  protected clearSelection(): void {
    this.active = [];
    this.$emit('clearSelection');
  }

  @Watch('active')
  protected onSelect(selectArray: string[]): void {
    if (selectArray.length > 0) {
      const selectedValueId = selectArray[0];
      if (selectedValueId !== this.INVALID_ID) {
        this.$emit('change', selectedValueId);
      }
    }
  }

  protected get NodeType(): Record<string, string> {
    return NodeType;
  }
}
